var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        version: "1.0",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "20px",
        height: "20px",
        viewBox: "0 0 64 64",
        "enable-background": "new 0 0 64 64",
        "xml:space": "preserve",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M32,0c-8.477,0-16.178,3.302-21.903,8.683L9,7.585V4.999c0-0.168-0.051-0.318-0.124-0.457\n\tC8.862,4.479,8.827,4.411,8.747,4.331L4.708,0.292H4.707C4.526,0.11,4.276-0.001,4-0.001c-0.553,0-1,0.447-1,1v2H1\n\tc-0.553,0-1,0.447-1,1c0,0.276,0.112,0.526,0.293,0.707v0.001l3.999,3.998c0.001,0.001,0.001,0.001,0.001,0.001l0.041,0.041\n\tc0.08,0.08,0.147,0.115,0.21,0.129C4.682,8.948,4.833,8.999,5,8.999h2.586l1.097,1.098C3.303,15.821,0,23.522,0,32\n\tc0,17.673,14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,59.999c-15.464,0-28-12.536-28-28c0-7.372,2.854-14.074,7.511-19.075\n\tl2.828,2.829C10.405,20.026,8,25.731,8,31.999c0,13.255,10.745,24,24,24s24-10.745,24-24s-10.745-24-24-24\n\tc-6.268,0-11.972,2.404-16.247,6.34l-2.828-2.829c5-4.657,11.703-7.511,19.075-7.511c15.464,0,28,12.536,28,28\n\tS47.464,59.999,32,59.999z M20.013,21.426C17.523,24.247,16,27.94,16,31.999c0,8.837,7.163,16,16,16s16-7.163,16-16s-7.163-16-16-16\n\tc-4.059,0-7.752,1.523-10.573,4.013l-2.828-2.828c3.548-3.212,8.238-5.185,13.401-5.185c11.046,0,20,8.954,20,20s-8.954,20-20,20\n\ts-20-8.954-20-20c0-5.163,1.973-9.854,5.185-13.401L20.013,21.426z M25.687,27.1C24.633,28.454,24,30.151,24,32c0,4.418,3.582,8,8,8\n\ts8-3.582,8-8s-3.582-8-8-8c-1.848,0-3.545,0.633-4.899,1.686l-2.845-2.845c2.091-1.77,4.791-2.842,7.744-2.842\n\tc6.627,0,12,5.373,12,12s-5.373,12-12,12s-12-5.373-12-12c0-2.953,1.072-5.653,2.842-7.744L25.687,27.1z M31.293,32.706\n\tc0.391,0.391,1.023,0.391,1.414,0s0.391-1.023,0-1.414l-2.727-2.727C30.575,28.215,31.26,28,32,28c2.209,0,4,1.791,4,4s-1.791,4-4,4\n\ts-4-1.791-4-4c0-0.741,0.215-1.426,0.566-2.021L31.293,32.706z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }